var today = new Date(),
    btacal = {
        firstOccurrence: null,
        calendar: null,
        init: function () {
            this.dropdowns();
            btacal.calendar = $('#bta-calendar').fullCalendar({
                eventLimit: true,
                views: {
                    month: {
                        eventLimit: 3
                    },
                    week:  {
                        eventLimit: 100
                    }
                }, 
                firstDay: 1,
                displayEventTime :  false, // H(:mm) for 24 hour clock
                defaultView: ($(window).width() < 789 ? 'listMonth' : 'month'),
                defaultDate: btacal.lastDate(),
                contentHeight: 'auto',
                header: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'month,basicWeek'
                },
                loading: function (isLoading) {
                    if (isLoading) {
                        $('#bta-loading').fadeIn();
                    } else {
                        $('#bta-loading').fadeOut();
                    }
                },
                eventSources: [
                    { events: btacal.fetchScheduledProducts },
                    { events: btacal.fetchAnnouncements }
                ],
                eventRender: function (event, element) {
                    if (event.end < today) {
                        element.addClass('past-event');
                        $(element).attr('href', '/products/' + event.handle).attr('target', '_blank');
                        if($(window).width() < 789){
                            $(element).find('a').attr('href', '/products/' + event.handle).attr('target', '_blank');
                        }
                    } else {
                        if (event.bookedOut) {
                            element.addClass('booked-out');
                            element.find('.fc-list-item-title').append($('<br><small>Sold Out!</small>'));
                        } else {
                            if (event.remainingSpaces) {
                                element.find('.fc-list-item-title').append($('<br><small>' + (event.remainingSpaces) + ' spots left</small>'));
                            }
                        }
                        $(element).attr('target', '_blank');
                        if($(window).width() < 789){
                            $(element).find('a').attr('target', '_blank');
                        }
                    }
                    
                    /* location_finder */
                    if (event.icon) {
                        btacal.renderIcon(event, element);
                    }
                    /* MOBILE, variables: backgroundColor, borderColor, textColor */
                    if($(window).width() < 798 && element.find('.fc-list-item-marker').length > 0) {
                        let color_options = {
                            'background-color': event.backgroundColor,
                            'border-color': event.borderColor,
                            'color': event.textColor
                        };
                        element.find('.fc-list-item-marker').css(color_options);
                        element.find('.fc-list-item-title').css(color_options);
                    }

                },
                windowResize: function (view) {
                    btacal.resize()
                },
                viewRender: function (view, element) {
                    localStorage.setItem('__bta.calendar-view', view.name);
                    localStorage.setItem('__bta.calendar-date', view.intervalStart.format());
                }
            });

            btacal.windowWidth = $(window).width();
            btacal.resize();

        },
        getLocation: function (event, div) {
            event.locations.forEach(function (location) {
                var localizator = {
                    start: event.start.format(),
                    end: event.start.format(),
                    handle: event.handle,
                    variant: "",
                    filter_location: location.id,
                    filter_location_occurrences: true,
                    tags: $('.bta-type-select .selected').data('value')
                }
                $.getJSON("https://aquanauts-uk.bookthatapp.com/availability/schedule.json?callback=?", localizator, function (data) {
                    if (data.schedule.length == 1) {
                        let locationDiv = `<p 
                            class="check-duplicates" data-id="${event.id}" data-handle="${event.handle}" 
                            data-location="${location.id}" data-time="${event.start[4]}:${event.start[5]}">${location.name}</p>`;
                            
                        if (div.find('.fc-list-item-marker').length > 0) {
                            div.find('.fc-list-item-title').append(locationDiv);
                        } else {
                            let $appendThis = div.find('.fc-content')
                            if(div.find('.text').length > 0){
                                $appendThis = div.find('.text');
                            }
                            $appendThis.append(locationDiv);
                        }
                    }
                });
            })
        },
        dropdowns: function () {
            let  types_array = [], types_to_filter = {};
            productsObject.forEach(function(product){
                if(product['metadata_definitions'] && product.metadata_definitions['product_type'] && !types_array.includes(product.metadata_definitions.product_type)){
                    $('.bta-type-select').append(`<div class="select-item" data-value="${product.metadata_definitions.product_type}">${product.metadata_definitions.product_type}</div>`)
                    types_array[types_array.length] = product.metadata_definitions.product_type;
                }
                if(product['metadata_definitions'] && product.metadata_definitions['product_type']){
                    let array = types_to_filter[product.metadata_definitions.product_type];
                    if(array) {
                        types_to_filter[product.metadata_definitions.product_type][array.length] = product.handle;

                    } else {
                        types_to_filter[product.metadata_definitions.product_type] = [product.handle];
                    }
                }
            });
            // on click
            $('#bta-product-select, #bta-variant-select, #bta-location-select, #bta-tags, #bta-type-select').change(function () {
                let input = $(this).val();
                btacal.calendar.fullCalendar('refetchEvents');
                if($(this).attr('id') === 'bta-type-select' && types_to_filter[input]) {
                    $('.bta-product-select > div').each(function () {
                        if($(this).data('value') == '' || types_to_filter[input].includes($(this).data('value'))){
                            $(this).show();
                        } else {
                            $(this).hide();
                        }
                    })
                } else if($(this).attr('id') === 'bta-type-select'){
                    $('.bta-product-select > div').show();
                }
            })
            // on focus
            $('.cal-drop-container input').on('keyup focus', function () {
                let selectBox = $(this).next();
                selectBox.addClass('active');
            });
            // on keyup
            $('.cal-drop-container input').on('keyup', function () {
                let selectBox = $(this).next(), input = $(this).val();
                selectBox.addClass('active');
                selectBox.find('.select-item:not(.selected)').each(function () {
                    if (!$(this).text().toLowerCase().includes(input.toLowerCase())) {
                        $(this).hide();
                    } else {
                        $(this).show()
                    }
                });
            });
            // clicks
            $('body').on('click', '.select-item',function () {
                let selectBox = $(this).parent();
                selectBox.find('.selected').removeClass('selected');
                $(this).addClass('selected');
                selectBox.prev().val($(this).text()).trigger('change');
                selectBox.removeClass('active')
            });
            // unclick
            $('.cal-drop-container input').on('focusout', function () {
                let selectBox = $(this).next()
                setTimeout(function(){
                    selectBox.removeClass('active')
                }, 200)
            });
        },
        fetchScheduledProducts: function (start, end, tz, callback) {
            var params = {
                start: start.format(),
                end: end.format(),
                handle: $('.bta-product-select .selected').data('value'),
                variant: "",
                filter_location_occurrences: true,
                tags: $('.bta-type-select .selected').data('value')
            }
            let events = [];
            $.getJSON("https://aquanauts-uk.bookthatapp.com/availability/schedule.json?callback=?", params, function (data) {
                callback($.map(data.schedule, function (item, n) {
                    let string = item.handle + JSON.stringify(item.start);
                    if (!events.includes(string)) {
                        events[events.length] = string;
                        var result = $.extend(item, {
                            start: new Date(item.start[0], item.start[1] - 1, item.start[2], item.start[3], item.start[4], item.start[5]),
                            end: new Date(item.end[0], item.end[1] - 1, item.end[2], item.end[3], item.end[4], item.end[5])
                        });

                        // prevent clicking through to past events or products already booked out
                        if (result.start < today || result.bookedOut) {
                            delete result.url;
                        }

                        return result;
                    }
                }));

                if (data.first_occurrence) {
                    var occurrence = new Date(data.first_occurrence[0], data.first_occurrence[1] - 1, data.first_occurrence[2], data.first_occurrence[3], data.first_occurrence[4], data.first_occurrence[5]);

                    if (!btacal.firstOccurrence && !moment(occurrence).isBetween(start, end)) {
                        btacal.firstOccurrence = occurrence;
                        btacal.calendar.fullCalendar('gotoDate', occurrence);
                    }
                }
            });
        },
        fetchAnnouncements: function (start, end, tz, callback) {
            var params = {
                start: start.format(),
                end: end.format()
            }

            $.getJSON("https://aquanauts-uk.bookthatapp.com/calendar/events.json?callback=?", params, function (data) {
                callback($.map(data.events, function (item, n) {
                    var result = $.extend(item, {
                        start: new Date(item.start[0], item.start[1] - 1, item.start[2], item.start[3], item.start[4], item.start[5]),
                        end: new Date(item.end[0], item.end[1] - 1, item.end[2], item.end[3], item.end[4], item.end[5]),
                        allDay: item.all_day
                    });

                    return result;
                }));
            });
        },
        resize: function () {
            var newWidth = $(window).width();
            if (newWidth != btacal.windowWidth) {
                btacal.calendar.fullCalendar('changeView', newWidth < 514 ? 'listMonth' : 'month');
                btacal.windowWidth = newWidth;
            }
        },
        renderImage: function (event, element) {
            var parts = event.image.split('?'),
                image = parts[0],
                index = image.lastIndexOf('.'),
                ext = image.substr(index),
                path = image.substr(0, index),
                div = $('<div>', { 'class': 'fc-thumb' }),
                img = $('<img>', { 'src': path + "_small" + ext + "?_=" + parts[1] });

            if (element.find('.fc-list-item-marker').length > 0) {
                element.find('.fc-list-item-marker').empty().append(div.append(img));
            }
        },
        renderIcon: function (event, element) {
            var cssClass = 'fa ' + event.icon;
            var i = $('<i>', { 'class': cssClass, 'css': { 'margin': '5px' } });
            element.find('.fc-content').prepend(i);
        },
        variants: null,
        loadStyleSheet: function(url) {
            if (document.createStyleSheet) {
                document.createStyleSheet(url);
            } else {
                var link = document.createElement('link');
                link.rel = 'stylesheet';
                link.type = 'text/css';
                link.href = url;
                document.getElementsByTagName('head')[0].appendChild(link);
            }
        },
        lastDate: function() {
            var rememberedDate = localStorage.getItem('__bta.calendar-date'),
                result = null;

            if (rememberedDate && moment(rememberedDate).isSameOrAfter()) { // ignore if date is in the past
                result = rememberedDate;
            }

            return result;
        }
}

btacal.loadStyleSheet("//cdn.bookthatapp.com/fullcalendar2/fullcalendar.css");
btacal.loadStyleSheet("//cdn.bookthatapp.com/stylesheets/bta-calendar.css");
btacal.loadStyleSheet("//maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");

window.addEventListener("pageshow", function (event) {
    btacal.init();
});